import mobile from "./mobile.png";
const projects = [
  {
    name: "Image Tools",
    img: mobile,
    about:
      "Full Stack, scalable and user-friendly web applications with all Image Tools",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "https://imagetols.netlify.app/",
  },
  {
    name: "NoteBook App",
    img: mobile,
    about:
      "Full Stack, scalable and user-friendly web applications with Note's making with application featuring a custom authentication validation system/API.",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "https://notebooksecure.netlify.app/",
  },
  {
    name: "Ecommerce Clone",
    img: mobile,
    about:
      "Full Stack, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "http://e-comr.netlify.app/",
  },
  // {
  //   name: "Quizz App",
  //   img: mobile,
  //   about:
  //     "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
  //   tech: ["Html", "CSS", "Javascript", "Java", "React"],
  //   github: "Github",
  //   live: "Live",
  //   details: "https://demottest.netlify.app/",
  // },
];
export default projects;

export const projectsFull = [
  {
    name: "Ecommerce Clone",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "http://e-comr.netlify.app/",
  },
  {
    name: "NoteBook",
    img: mobile,
    about:
      "Full Stack, scalable and user-friendly web applications with Note's making with application featuring a custom authentication validation system/API.",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "https://notebooksecure.netlify.app/",
  },

  {
    name: "Image Tools",
    img: mobile,
    about:
      "Full Stack, scalable and user-friendly web applications with all Image Tools",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "https://imagetols.netlify.app/",
  },
  {
    name: "Social Media",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "ReactJS", "NodeJS"],
    github: "Github",
    live: "Live",
    details: "https://applicationuser.netlify.app/signin",
  },

  {
    name: "TextUtil",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "React"],
    github: "Github",
    live: "Live",
    details: "https://somnathtextutils.netlify.app/",
  },
  {
    name: "Data Visualization Dashboard",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "React", "Spring"],
    github: "Github",
    live: "Live",
    details: "https://dataviza.netlify.app/",
  },
  {
    name: "Color Selector",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "React"],
    github: "Github",
    live: "Live",
    details: "https://uilibraryassignment.netlify.app/",
  },
  {
    name: "Quizz App",
    img: mobile,
    about:
      "Full Stack Developer who loves building clean, scalable and user-friendly web applications",
    tech: ["Html", "CSS", "Javascript", "Java", "React"],
    github: "Github",
    live: "Live",
    details: "https://demottest.netlify.app/",
  },
];
